import FilterHeaderWithClearButton from './FilterHeaderWithClearButton';

export default FilterHeaderWithClearButton;
